import { commonTypes } from '@/reports/types';
import { LoadingDots } from '@/search/index';
import { Grid, Stack, Text, styled } from '@/theme/index';
import { formatShorthandDate } from '@/utils/formatShorthandDate/formatShorthandDate';

export const ObituaryGeneralInformationGrid = styled(Grid)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.secondary.main}`,
  width: '100%',
  minHeight: '100px',
  position: 'relative',
  padding: '0',
}));

export const TitleTextBox = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  top: '-20px',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  background: '#ffffff',
}));

export const InsightBox = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  paddingLeft: '15px',
  marginLeft: '0 !important',
  borderLeft: 'solid 2px #efefef',
  height: '70px',
  marginTop: '20px',

  [theme.breakpoints.down('sm')]: {
    width: '50%',
    marginLeft: '0 !important',
  },
}));

export const ItemGeneralInformation = ({
  itemTitle,
  itemValue,
  isLoading,
}: {
  itemTitle: string;
  itemValue: string | commonTypes.Date | null;
  isLoading: boolean;
}) => {
  if (isLoading && !itemValue) return <LoadingComponent />;

  if (!itemValue) return null;

  return (
    <InsightBox>
      <Text fontWeight="bold" textAlign="left">
        {itemTitle}
      </Text>
      <Text variant="body1" textAlign="left">
        {typeof itemValue === 'string'
          ? itemValue
          : formatShorthandDate(itemValue, true)}
      </Text>
    </InsightBox>
  );
};

const LoadingComponent = () => {
  return (
    <InsightBox>
      <LoadingDots count={4} />
    </InsightBox>
  );
};
